import React from 'react';
import { NavLink } from 'react-router-dom';

const AddMandateCrumb = () => <NavLink to="/core/mandates/add">Add Mandate</NavLink>;

export default AddMandateCrumb;
